import { createTheme } from '@mui/material/styles'
import darkScrollbar from "@mui/material/darkScrollbar"
import * as colors from '@mui/material/colors'

const brandColors = {
  orange: '#f88c2b',
  purple: '#2a2559',
  lightBlue: '#02a7e1',
  darkBlue: '#0d1e2e',
}

const theme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: brandColors.lightBlue,
    },
    secondary: {
      main: brandColors.darkBlue,
    },
    warning: {
      main: brandColors.orange,
    },
    typography: {
      fontFamily: [
        'proxima-nova',
        'sans-serif',
      ].join(',')
    },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: ({theme}) => ({
          ...darkScrollbar(),
          backgroundColor: theme.palette.primary.main,
        }),
      }
    },
    MuiLink: {
      defaultProps: {
        underline: 'none',
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          whiteSpace: 'nowrap',
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: ({theme}) => ({
          backgroundColor: theme.palette.secondary.dark,
        }),
      },
    }
  },
  jsonforms: {
    input: {
      delete: {
        display: 'none',
      }
    }
  }
})

global.theme = theme

export default theme
